import React from 'react';
import classnames from 'classnames';
import StartButton from './start_button.js';
import TextWithImages from './textWithImages';

const CustomQualified = ({ nextStep, content, reactWysiwig }) => {
  return (
    <div className="survey-layout_content -start">
      <div className="survey-start">
        <TextWithImages
          content={ content }
          className={
            classnames(
              "custom-qualify-content custom-title",
              {  "-react-wysiwig": reactWysiwig }
            )
          }
        />
        <StartButton nextStep={ () => { nextStep(); } } />
      </div>
    </div>
  );
};

export default CustomQualified;
